import _ from 'lodash';

import {
  FACTOR_DEFINITIONS,
  FACTOR_GROUP_LABELS,
  FactorGroup,
  WEIGHT_FIELD_KEYS,
} from './OptimizationStrategies.constants';

export const getFactorsByGroup = group =>
  FACTOR_DEFINITIONS.filter(factor => factor.group === group);

export const getGroupAverageWeight = (factorWeights, group) => {
  const factors = getFactorsByGroup(group);

  if (!factors.length) {
    return 0;
  }

  const sum = factors.reduce((acc, { key }) => acc + (factorWeights?.[key] || 0), 0);

  return Math.round(sum / factors.length);
};

export const getGroupSummaries = factorWeights =>
  Object.values(FactorGroup).map(group => ({
    group,
    label: FACTOR_GROUP_LABELS[group],
    average: getGroupAverageWeight(factorWeights, group),
  }));

export const extractFactorWeights = strategy => _.pick(strategy, WEIGHT_FIELD_KEYS);

export const parseStrategyFromApi = strategy => ({
  ...strategy,
  factorWeights: extractFactorWeights(strategy),
});

export const normalizeStrategyPayload = ({ name, factorWeights }) => ({
  name,
  ...factorWeights,
});
